import React from "react";
import {Box, ButtonBase, Popover, Stack, Typography} from "@mui/material";

// Callers with more than one call today, most calls first. callers: [{numberHash, number, calls, conversationIds}],
// onSelect(caller): open the caller's latest conversation.
export const RepeatCallersPopover = ({anchorEl, onClose, callers, onSelect}) => (
  <Popover
    anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={onClose} disableScrollLock
    anchorOrigin={{vertical: "bottom", horizontal: "left"}} transformOrigin={{vertical: "top", horizontal: "left"}}
    slotProps={{paper: {sx: {
      mt: 0.75, width: anchorEl?.offsetWidth, minWidth: 300, maxHeight: 420, borderRadius: "16px",
      boxShadow: "0 12px 32px rgba(35, 38, 77, 0.12)", p: 0.5,
    }}}}
  >
    <Box sx={{px: 1.5, pt: 1.5, pb: 1.25}}>
      <Typography sx={{fontSize: 11, fontWeight: 600, letterSpacing: "0.12em", color: "#8491F7"}}>TODAY</Typography>
      <Typography sx={{fontSize: 16, fontWeight: 700, color: "#23264D", letterSpacing: "-0.01em"}}>Repeat callers</Typography>
      <Typography sx={{fontSize: 12, color: "#8A8AA0"}}>
        {callers.length} {callers.length === 1 ? "number" : "numbers"} called more than once. Tap one to open their latest conversation.
      </Typography>
    </Box>
    <Stack gap={0.25} sx={{pb: 0.5}}>
      {callers.map((caller, index) => (
        <ButtonBase
          key={caller.numberHash} onClick={() => onSelect(caller)}
          sx={{
            width: "100%", display: "flex", alignItems: "center", gap: 1.5, px: 1.5, py: 1.25, borderRadius: "14px",
            textAlign: "left", transition: "background-color .15s ease", "&:hover": {bgcolor: "#F6F6FB"},
          }}
        >
          <Typography sx={{width: 16, flexShrink: 0, fontSize: 12, fontWeight: 600, color: "#B4B4C3", textAlign: "center"}}>
            {index + 1}
          </Typography>
          <Box sx={{flex: 1, minWidth: 0}}>
            <Typography noWrap sx={{fontSize: 14, fontWeight: 600, color: "#23264D"}}>{caller.number}</Typography>
            <Typography sx={{fontSize: 11, color: "#8A8AA0"}}>Latest conversation #{Math.max(...caller.conversationIds)}</Typography>
          </Box>
          <Typography sx={{
            flexShrink: 0, px: 1.25, py: 0.5, borderRadius: "999px", fontSize: 12, fontWeight: 700, whiteSpace: "nowrap",
            bgcolor: "rgba(132, 145, 247, 0.14)", color: "#4B55C9",
          }}>
            {caller.calls} calls
          </Typography>
        </ButtonBase>
      ))}
    </Stack>
  </Popover>
);
